import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-user-on-without-license-modal',
    imports: [CommonModule],
    templateUrl: './user-on-without-license-modal.component.html',
    styleUrl: './user-on-without-license-modal.component.scss'
})
export class UserOnWithoutLicenseModalComponent {

  constructor(
    private router: Router
  ){

  }

  public redirectToLicensesPage(){
    this.router.navigate(['/architect/profile/billing'], { queryParams: { tab: 'licence' } });
  }

}
